import { formAnatomy as parts } from "@chakra-ui/anatomy";
import { FormLabel, FormControl, Stack } from "@chakra-ui/react";
import { tempo } from "../system";
FormLabel.defaultProps = {
    color: 'text.neutral.secondary.default',
    fontSize: 'sm'
};
export { FormLabel, FormControl };
const baseStyleRequiredIndicator = {
    marginStart: 1,
    color: 'text.feedback.error.default'
};
export const FormContainer = tempo(Stack, {
    baseStyle: {
        alignItems: 'start',
        maxWidth: {
            base: 80,
            md: 96
        },
        mx: 'auto',
        spacing: '4'
    }
});
const baseStyleHelperText = {
    mt: 2,
    color: 'gray.500',
    lineHeight: 'normal',
    fontSize: 'sm',
    _dark: {
        color: 'whiteAlpha.600'
    }
};
const baseStyle = {
    container: {
        width: '100%',
        position: 'relative'
    },
    requiredIndicator: baseStyleRequiredIndicator,
    helperText: baseStyleHelperText
};
export const ThemedFormControl = {
    parts: parts.keys,
    baseStyle
};

//# sourceMappingURL=FormControl.js.map